import { Component, OnInit, ViewChild, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { NavbarSchema, NavbarMenuSection, NavbarLink } from 'shared/components/navbar/navbar.model';
import { AuthService } from 'core/auth.service';
import { Subscription } from 'rxjs';

import { L10nTranslationService } from 'angular-l10n';
import { SecurityService } from 'core/security.service';
import { ClientService } from 'core/client.service';
import { TenantModuleDto } from 'shared/service-clients/tenant';
import { ClassificationValues } from 'dtp/common/classification-value';
import { UserAccessDto } from 'shared/service-clients/security';
import { SamplicityPermission } from 'dtp/common/permissions';

@Component({
  selector: 'samplicity-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {

  @ViewChild('setupMenuTrigger') setupMenuTrigger: MatMenuTrigger;
  @ViewChild('navMenuTrigger') navMenuTrigger;
  @ViewChild('dropdownPane') dropdownPane;
  @ViewChild('nestedDropdownPane') nestedDropdownPane;
  @Input() navbarSchema: NavbarSchema;
  @Input() permissions:any;
  @Input() selectedClientId: string;

  isIE11: boolean;
  isSafari: boolean;
  isFirefox: boolean;
  isLoggedIn = false;
  isPermissionsLoaded = false;
  nestedDropdownMenuSections: NavbarMenuSection[];
  private securityServiceUserAccessSub: Subscription;
  showDashboard = false;
  isDTP:boolean = false;
  isFG:boolean = false;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    public router: Router,
    private authService: AuthService,
    private securityService: SecurityService,
    private clientService: ClientService
  ) {
    this.securityServiceUserAccessSub = this.securityService.onUserAccessChange.subscribe({
      next: (userAccess: UserAccessDto) => {
        // this.handleUserAccess(userAccess);
        this.refreshCurrentClientDetails();
      }
    });
  }

  ngOnInit() {
    this.setReuseRouteStrategy();
    this.checkBrowser();

    this.securityService.userAccessSubject.subscribe((userAccess: any) => {
      // this.handleUserAccess(userAccess);
        this.refreshCurrentClientDetails();
    });
    this.securityService.checkPermission(SamplicityPermission.Dashboard.DashboardView).then(x => {
      if (x) {        this.showDashboard = true;
      }
    });

    if (this.authService.isLoggedIn()) {
      this.isLoggedIn = true;
    }
  }

  ngOnDestroy() {
    if (this.securityServiceUserAccessSub) {
      this.securityServiceUserAccessSub.unsubscribe();
    }
  }

  checkPermissions(permissions: Array<string>) {
    for (const link of this.navbarSchema.links) {
      this.setMenuElementsVisibility(permissions, link);
    }

    if (this.navbarSchema.logoPermissions
      && this.navbarSchema.logoPermissions.length > 0
      && !this.hasAnyPermissions(permissions, this.navbarSchema.logoPermissions)) {
      this.navbarSchema.logoLink = undefined;
    }
    this.setDtrAndFgMenuVisibility();
  }

  private refreshCurrentClientDetails() {
    this.clientService.getCurrentClientDetails().subscribe((client) => {
      if (client) {
        if (client.tenantModules.length > 0) {
          const status = client.tenantModules[0].tenantModuleStatusClassificationValueId;
          const isActive = (
            status.toLowerCase() === ClassificationValues.TENANT_MODULE_STATUS_ACTIVE.toLowerCase()
            || status.toLowerCase() === ClassificationValues.TENANT_MODULE_STATUS_NEW.toLowerCase()
          );
          this.clientService.setIsCurrentClientActive(isActive);
        } else {
          this.clientService.setIsCurrentClientActive(false);
        }
        this.isDTP = client.tenantModules.some(a => a.moduleId == ClassificationValues.TENANT_MODULE_TYPE_DTP);
        this.isFG = client.tenantModules.some(a => a.moduleId == ClassificationValues.TENANT_MODULE_TYPE_FGPORTAL);
        this.setNavbar(this.permissions);
      }
      this.changeDetectorRef.detectChanges();
    });
  }

  setDtrAndFgMenuVisibility(): void {
    const observable = this.clientService.getCurrentClientDetails();
    observable.subscribe((client) => {
      if (client) {
        if (client.tenantModules.length === 1) {
          const status = client.tenantModules[0].tenantModuleStatusClassificationValueId;
          const isActive = (
            status === ClassificationValues.TENANT_MODULE_STATUS_ACTIVE
            || status === ClassificationValues.TENANT_MODULE_STATUS_NEW
          );
          this.clientService.setIsCurrentClientActive(isActive);
        } else {
          this.clientService.setIsCurrentClientActive(false);
        }
        this.setTenantModules(client.tenantModules);
      }
      this.isPermissionsLoaded = true;
      this.changeDetectorRef.detectChanges();
    });
  }

  setTenantModules(tenantModules: Array<TenantModuleDto>) {
    if (tenantModules) {
      for (const navbarSchemaLink of this.navbarSchema.links) {
        if (navbarSchemaLink.menu && navbarSchemaLink.menu.length > 0) {
          for (const menu of navbarSchemaLink.menu){
            if (menu.classificationType === 'TENANT_MODULE') {
              let showMenu = false;
              for (const link of menu.links) {
                if (link.classificationValue === ClassificationValues.TENANT_MODULE_TYPE_DTP) {
                  const tm = tenantModules.find(x => x.moduleId === link.classificationValue);
                  if (tm) {
                    link.hide = false;
                    link.url = tm.tenantModuleUrlText;
                    showMenu = true;
                  } else {
                    link.hide = true;
                  }
                }
                if (link.classificationValue === ClassificationValues.TENANT_MODULE_TYPE_FGPORTAL) {
                  const tm = tenantModules.find(x => x.moduleId === link.classificationValue);
                  if (tm) {
                    link.hide = false;
                    link.url = tm.tenantModuleUrlText;
                    showMenu = true;
                  } else {
                    link.hide = true;
                  }
                }
              }
              if (showMenu) {
                menu.hide = false;
              } else {
                menu.hide = true;
              }
            }
          }
        }
      }
    }
  }

  setMenuElementsVisibility(userPermissions: string[], navbarLink: NavbarLink) {
    if (navbarLink.menu && navbarLink.menu.length > 0) {
      for (const menu of navbarLink.menu) {
        for (const link of menu.links) {
          this.setMenuElementsVisibility(userPermissions, link);
        }
        if (menu.links.find(x => x.hide === false || x.hide === undefined)) {
          menu.hide = false;
        } else {
          menu.hide = true;
        }
      }
      if (navbarLink.menu.find(x => x.hide === false || x.hide === undefined)) {
        navbarLink.hide = false;
      } else {
        navbarLink.hide = true;
      }
    } else {
      if (navbarLink.permissions && navbarLink.permissions.length > 0) {
        if (this.hasAnyPermissions(userPermissions, navbarLink.permissions)) {
          navbarLink.hide = false;
        } else {
          navbarLink.hide = true;
        }
      } else {
        navbarLink.hide = false;
      }
    }
  }

  hasAnyPermissions(userPermissions: string[], itemPermissions: string[]): boolean {
    if (userPermissions) {
      for (const permission of itemPermissions) {
        if (userPermissions.find(x => x.toLowerCase() === permission.toLowerCase())) {
          return true;
        }
      }
    }
    return false;
  }

  checkBrowser(): void {
    const iePattern = new RegExp(/(?:\b(MS)?IE\s+|\bTrident\/7\.0;.*\s+rv:)(\d+)/);
    const ffPattern = new RegExp(/Firefox/);
    if (navigator.userAgent.search(iePattern) > 0) {
      this.isIE11 = true;
    }
    if (navigator.userAgent.search(ffPattern) > 0) {
      this.isFirefox = true;
    }
  }

  changeRoute(url: string): void {
    this.router.navigateByUrl(url);
  }

  setReuseRouteStrategy(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
  }

  openNavMenu(timeout: number, navMenuTrigger: any, setupMenuTrigger: MatMenuTrigger): void {
    setTimeout(() => this.processOpen(navMenuTrigger, setupMenuTrigger), timeout);
  }

  processOpen(navMenuTrigger: any, setupMenuTrigger: MatMenuTrigger): void {
    if (navMenuTrigger && navMenuTrigger.parentElement && navMenuTrigger.parentElement.querySelector(':hover') === navMenuTrigger) {
      setupMenuTrigger.openMenu();
    }
  }

  closeNavMenu(dropdownPane: any, nestedDropdownPane: any, setupMenuTrigger: MatMenuTrigger): void {
    setTimeout(() => this.processClose(dropdownPane, nestedDropdownPane, setupMenuTrigger), 250);
  }

  processClose(dropdownPane: any, nestedDropdownPane: any, setupMenuTrigger: MatMenuTrigger): void {
    if (nestedDropdownPane && nestedDropdownPane.parentElement
      && nestedDropdownPane.parentElement.querySelector(':hover') === nestedDropdownPane) {
      return;
    } else if (dropdownPane.parentElement.querySelector(':hover') === dropdownPane) {
      return;
    } else {
      setupMenuTrigger.closeMenu();
      this.nestedDropdownMenuSections = [];
    }
  }

  setNestedDropdownMenu(sections: NavbarMenuSection[]): void {
    this.nestedDropdownMenuSections = sections;
  }

  navigateToLogoLink(logoLink: string): void {
    if (logoLink !== undefined && logoLink.length > 0) {
      this.router.navigate([logoLink]);
    }
  }

  navigateToUrl(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }

  menuOpened(navMenu: any): void {
    navMenu.className = 'nav-item hovered';
  }

  menuClosed(navMenu): void {
    navMenu.className = 'nav-item';
  }

  private handleUserAccess(userAccess: UserAccessDto) {
    if (userAccess) {
      this.checkPermissions(userAccess.permissions);
    }
  }

  isDropdownLinkActive(link: NavbarLink): boolean {
    let hasActiveLink = false;
    if (link.menu && link.menu.length > 0) {
      link.menu.forEach((menuSection) => {
        if (menuSection.links && menuSection.links.length > 0) {
          menuSection.links.forEach(menuLink => {
            if (menuLink.menuChildLinks) {
              menuLink.menuChildLinks.forEach((childLink) => {
                const fullLink = menuLink.link + childLink;
                if (this.router.isActive(fullLink, false)) {
                  hasActiveLink = true;
                }
              });
            } else if (!menuLink.menu) {
              if ( this.router.isActive(menuLink.link, true)) {
                hasActiveLink = true;
              }
            } else {
              menuLink.menu.forEach((subMenu) => {
                const index = subMenu.links.findIndex((subLink) => this.router.isActive(subLink.link, true));
                if ( index > -1) {
                  hasActiveLink = true;
                }
              });
            }
          });
        }
      });
    }
    return hasActiveLink;
  }

  setNavbar(userPermissions?: string[]): void {
    if (!userPermissions) {
      userPermissions = [];
    }
    this.navbarSchema = new NavbarSchema();
    this.navbarSchema.logoPermissions = [];
    this.navbarSchema.links = [];
    this.navbarSchema.logoLink = `/${this.selectedClientId}/dashboard`;
    this.navbarSchema.logoTitle = 'Navbar.SamplicityPlatform';
    this.navbarSchema.links = [
      {
        display: 'Navbar.Orders',
        link: `/${this.selectedClientId}/orders`,
        id: 'linkOrders',
        hide: !this.hasPermission(SamplicityPermission.Order.OrdersListView, userPermissions),
        permissions: [SamplicityPermission.Order.OrdersListView]
      },

      {
        display: 'Navbar.DataEntry.DataEntry',
        id: 'linkDataEntry',
        hide: !this.hasAnyPermissions([SamplicityPermission.DataEntryOrder.DataEntryOrderListView, SamplicityPermission.DataEntryCertificate.DataEntryCertificationView], userPermissions),
        menu: [
          {
            links: [
              {
                display: 'Navbar.DataEntry.Orders',
                link: `/${this.selectedClientId}/orders/data-entry`,
                id: 'linkDataEntryOrders',
                hide: !this.hasPermission(SamplicityPermission.DataEntryOrder.DataEntryOrderListView, userPermissions),
                permissions: [SamplicityPermission.DataEntryOrder.DataEntryOrderListView]
              },
              {
                display: 'Navbar.DataEntry.Certificates',
                link: `/${this.selectedClientId}/admin/certificates/data-entry-certificates`,
                id: 'linkDataEntryCertificate',
                hide: !(this.hasPermission(SamplicityPermission.DataEntryCertificate.DataEntryCertificationView, userPermissions) && this.isFG),
                permissions: [SamplicityPermission.DataEntryCertificate.DataEntryCertificationView]
              },
            ]
          }]
      },
      {
        display: 'Navbar.MitigationOrders.Mitigation',
        id: 'linkMitigationOrders',
        hide: !this.hasAnyPermissions([SamplicityPermission.MitigationOrder.MitigationOrdersListView,
          SamplicityPermission.MitigationCertificate.MitigationCertificateListView], userPermissions),
        permissions: [SamplicityPermission.MitigationOrder.MitigationOrdersListView],
        menu:[
          {
            links: [
              {
                display: 'Navbar.MitigationOrders.ExceptionOrders',
                link: `/${this.selectedClientId}/orders/mitigation/exception`,
                id: 'childlinkMitigateExceptionOrders',
                hide: !this.hasPermission(SamplicityPermission.MitigationOrder.MitigationOrdersListView, userPermissions),
                permissions: [SamplicityPermission.MitigationOrder.MitigationOrdersListView],
              },
              {
                display: 'Navbar.MitigationOrders.OnHoldOrders',
                link: `/${this.selectedClientId}/orders/mitigation/on-hold`,
                id: 'childlinkMitigateOnHoldOrders',
                hide: !this.hasPermission(SamplicityPermission.OnHoldOrder.OnHoldOrderListView, userPermissions),
                permissions: [SamplicityPermission.OnHoldOrder.OnHoldOrderListView],
              },
              {
                display: 'Navbar.MitigationOrders.Certification',
                link: `/${this.selectedClientId}/admin/certificates/mitigation`,
                id: 'childlinkCertification',
                hide: !(this.hasPermission(SamplicityPermission.MitigationCertificate.MitigationCertificateListView, userPermissions) && (this.isFG)),
                permissions: [SamplicityPermission.MitigationCertificate.MitigationCertificateListView],
              }
            ]
          }
        ] 
      },
      {
        display: 'Navbar.Offers',
        link: `/${this.selectedClientId}/admin/offers`,
        id: 'linkOffers',
        hide: !(this.hasPermission(SamplicityPermission.Offer.OfferListView, userPermissions) && this.isDTP),
        permissions: [SamplicityPermission.Offer.OfferListView]
      },
      {
        display: 'Navbar.Recipients.Recipients',
        id: 'linkRecipient',
        hide: !this.hasAnyPermissions([SamplicityPermission.HCP.HCPListView,SamplicityPermission.Pharmacist.PharmacistListView], userPermissions),
        menu:[
          {
            links:[
              {
                display: 'Navbar.Recipients.Hcps',
                link: `/${this.selectedClientId}/admin/hcps`,
                id: 'linkHcps',
                hide: !(this.hasPermission(SamplicityPermission.HCP.HCPListView, userPermissions) && this.isDTP),
                permissions: [SamplicityPermission.HCP.HCPListView]
              },
              {
                display: 'Navbar.Recipients.Pharmacists',
                link: `/${this.selectedClientId}/admin/pharmacists`,
                id: 'linkPharmacists',
                hide: !(this.hasPermission(SamplicityPermission.Pharmacist.PharmacistListView, userPermissions) && this.isFG),
                permissions: [SamplicityPermission.Pharmacist.PharmacistListView]
              }
            ]
          }
        ],
      },  
      {
        display: 'Navbar.Communications',
        link: `/${this.selectedClientId}/communications`,
        id: 'linkCommunications',
        hide: !this.hasPermission(SamplicityPermission.Communication.CommunicationListView, userPermissions),
        permissions: [SamplicityPermission.Communication.CommunicationListView]
      },
      {
        display: 'Navbar.Reports',
        link: `/${this.selectedClientId}/reports`,
        id: 'linkReports',
        hide: !this.hasPermission(SamplicityPermission.Reporting.ReportsView, userPermissions),
        permissions: [SamplicityPermission.Reporting.ReportsView]
      },
      {
        display: 'Navbar.Administration.Administration',
        link: '/' + this.selectedClientId + '/admin',
        id: 'linkAdmin',
        hide: !this.hasAnyPermissions([
          SamplicityPermission.User.UserListView,
          SamplicityPermission.Client.ClientDetailView,
          SamplicityPermission.Brand.BrandListView,
          SamplicityPermission.Product.ProductListView,
          SamplicityPermission.Customer.CustomerListView,
          SamplicityPermission.Program.ProgramListView,
          SamplicityPermission.DNH.DNHListView
        ], userPermissions),
        menu: [
          {
            title: 'Navbar.Administration.SystemAdministration',
            hide: !this.hasAnyPermissions([
              SamplicityPermission.User.UserListView
            ], userPermissions),
            links: [
              {
                display: 'Navbar.Administration.Users.Users',
                link: '/' + this.selectedClientId + '/admin/users',
                id: 'linkUsers',
                menu: [
                  {
                    links: [
                      {
                        display: 'Navbar.Administration.Users.ExistingUsers',
                        link: '/' + this.selectedClientId + '/admin/users',
                        id: 'linkExistingUsers',
                        hide: !this.hasPermission(SamplicityPermission.User.UserListView, userPermissions),
                        permissions: [SamplicityPermission.User.UserListView]
                      },
                      {
                        display: 'Navbar.Administration.Users.NewUsers',
                        link: '/' + this.selectedClientId + '/admin/users/ad-users',
                        id: 'linkNewUsers',
                        hide: !this.hasPermission(SamplicityPermission.User.UserListView, userPermissions),
                        permissions: [SamplicityPermission.User.UserListView]
                      },
                    ]
                  }
                ]
              },
              {
                display: 'Navbar.Administration.Roles',
                link: '/' + this.selectedClientId + '/admin/roles',
                id: 'linkRoles',
                hide: !this.hasPermission(SamplicityPermission.Role.ViewRoleList, userPermissions),
                permissions: [SamplicityPermission.Role.ViewRoleList]
              }
            ]
          },
          {
            title: 'Navbar.Administration.ClientAdministration',
            hide: !this.hasAnyPermissions([
              SamplicityPermission.Client.ClientDetailView,
              SamplicityPermission.Brand.BrandListView,
              SamplicityPermission.Product.ProductListView,
              SamplicityPermission.Program.ProgramListView,
              SamplicityPermission.DNH.DNHListView
            ], userPermissions),
            links: [
              {
                display: 'Navbar.Administration.ClientDetail',
                link: '/' + this.selectedClientId + '/admin/client/',
                id: 'linkClientDetail',
                hide: !this.hasPermission(SamplicityPermission.Client.ClientDetailView, userPermissions),
                permissions: [SamplicityPermission.Client.ClientDetailView],
                menuChildLinks: ['existing', 'new']
              },
              {
                display: 'Navbar.Administration.Brands',
                link: '/' + this.selectedClientId + '/admin/brands',
                id: 'linkBrand',
                hide: !this.hasPermission(SamplicityPermission.Brand.BrandListView, userPermissions),
                permissions: [SamplicityPermission.Brand.BrandListView]
              },
              {
                display: 'Navbar.Administration.Products.Products',
                link: '',
                id: 'linkProducts',
                hide: !this.hasAnyPermissions([
                  SamplicityPermission.Product.ProductListView
                ], userPermissions),
                menu: [
                  {
                    links: [
                      {
                        display: 'Navbar.Administration.Products.ExistingProducts',
                        link: '/' + this.selectedClientId + '/admin/products/existing',
                        icon: '',
                        id: 'linkExistingProducts',
                        hide: !this.hasPermission(SamplicityPermission.Product.ProductListView, userPermissions),
                        permissions: [SamplicityPermission.Product.ProductListView]
                      },
                      {
                        display: 'Navbar.Administration.Products.NewProducts',
                        link: '/' + this.selectedClientId + '/admin/products/new',
                        icon: '',
                        id: 'linkNewProducts',
                        hide: !this.hasPermission(SamplicityPermission.Product.ProductListView, userPermissions),
                        permissions: [SamplicityPermission.Product.ProductListView]
                      },
                    ]
                  }
                ]
              },
              {
                display: 'Navbar.Administration.Customers',
                link: '/' + this.selectedClientId + '/admin/customers',
                id: 'linkCustomer',
                hide:!this.hasPermission(SamplicityPermission.Customer.CustomerListView, userPermissions),
                permissions: [SamplicityPermission.Customer.CustomerListView]
              },
              {
                display: 'Navbar.Administration.Programs',
                link: '/' + this.selectedClientId + '/admin/programs',
                id: 'linkPrograms',
                hide: !this.hasPermission(SamplicityPermission.Program.ProgramListView, userPermissions),
                permissions: [SamplicityPermission.Program.ProgramListView]
              },
              {
                display: 'Navbar.Administration.DoNotHonorExlusions',
                link: '/' + this.selectedClientId + '/admin/donothonorexclusions',
                id: 'linkDoNotHonorExlusions',
                hide: !this.hasPermission(SamplicityPermission.DNH.DNHListView, userPermissions),
                permissions: [SamplicityPermission.DNH.DNHListView]
              }
            ]
          },
          {
            title: 'Navbar.Administration.BatchAdministration',
            hide: !this.hasAnyPermissions([
              SamplicityPermission.Aggregation.AggregationView, SamplicityPermission.Aggregation.AggregationViewAll,
              SamplicityPermission.Aggregation.AggregationEdit], userPermissions),
            links: [
              {
                display: 'Navbar.Administration.Batches',
                link: '/' + this.selectedClientId + '/admin/batches',
                id: 'linkBatch',
                hide: !this.hasAnyPermissions([
                  SamplicityPermission.Aggregation.AggregationView, SamplicityPermission.Aggregation.AggregationViewAll,
                  SamplicityPermission.Aggregation.AggregationEdit], userPermissions),
                permissions: [SamplicityPermission.Aggregation.AggregationView, SamplicityPermission.Aggregation.AggregationViewAll]
              }
            ]
          }
        ]
      }
    ];
  }

  private hasPermission(permission: string, userPermissions: string[]){
    return this.hasAnyPermissions([permission], userPermissions);
  }

}
